import angular from 'angular'
import strAbridge from './strAbridge'
import strSafe from './strSafe'
import picklist from './picklistFilter'
import debug from './debug'
import commentDateDisp from './dateDisp'
import isPickedSlug from './isPickedSlug'
import abbreviatedUrl from './abbreviatedUrl'

export default angular
  .module('ellipsis.filters', [])
  .filter('strAbridge', strAbridge)
  .filter('strSafe', strSafe)
  .filter('picklist', picklist)
  .filter('dateDisp', commentDateDisp)
  .filter('debug', debug)
  .filter('commentDateDisp', commentDateDisp)
  .filter('isPickedSlug', isPickedSlug)
  .filter('abbreviatedUrl', abbreviatedUrl)
